import { render, staticRenderFns } from "./infosh.vue?vue&type=template&id=913a90e6&scoped=true&"
import script from "./infosh.vue?vue&type=script&lang=js&"
export * from "./infosh.vue?vue&type=script&lang=js&"
import style0 from "./infosh.vue?vue&type=style&index=0&id=913a90e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a90e6",
  null
  
)

export default component.exports